import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2826_6939)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24,
				r: 23,
				stroke: "black",
				strokeOpacity: .08,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-2-inside-1_2826_6939",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M48 24C48 20.8483 47.3792 17.7274 46.1731 14.8156C44.967 11.9038 43.1992 9.25804 40.9706 7.02944C38.742 4.80083 36.0962 3.033 33.1844 1.82689C30.2726 0.620778 27.1517 -1.37766e-07 24 0V2.04C26.8838 2.04 29.7394 2.60801 32.4037 3.7116C35.068 4.8152 37.4889 6.43276 39.5281 8.47193C41.5672 10.5111 43.1848 12.932 44.2884 15.5963C45.392 18.2606 45.96 21.1162 45.96 24H48Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48 24C48 20.8483 47.3792 17.7274 46.1731 14.8156C44.967 11.9038 43.1992 9.25804 40.9706 7.02944C38.742 4.80083 36.0962 3.033 33.1844 1.82689C30.2726 0.620778 27.1517 -1.37766e-07 24 0V2.04C26.8838 2.04 29.7394 2.60801 32.4037 3.7116C35.068 4.8152 37.4889 6.43276 39.5281 8.47193C41.5672 10.5111 43.1848 12.932 44.2884 15.5963C45.392 18.2606 45.96 21.1162 45.96 24H48Z",
				stroke: "#4F49BA",
				strokeWidth: 4,
				mask: "url(#path-2-inside-1_2826_6939)"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-3-inside-2_2826_6939",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M24 48C27.1517 48 30.2726 47.3792 33.1844 46.1731C36.0962 44.967 38.742 43.1992 40.9706 40.9706C43.1992 38.742 44.967 36.0962 46.1731 33.1844C47.3792 30.2726 48 27.1517 48 24L45.96 24C45.96 26.8838 45.392 29.7394 44.2884 32.4037C43.1848 35.068 41.5672 37.4889 39.5281 39.5281C37.4889 41.5672 35.068 43.1848 32.4037 44.2884C29.7394 45.392 26.8838 45.96 24 45.96V48Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 48C27.1517 48 30.2726 47.3792 33.1844 46.1731C36.0962 44.967 38.742 43.1992 40.9706 40.9706C43.1992 38.742 44.967 36.0962 46.1731 33.1844C47.3792 30.2726 48 27.1517 48 24L45.96 24C45.96 26.8838 45.392 29.7394 44.2884 32.4037C43.1848 35.068 41.5672 37.4889 39.5281 39.5281C37.4889 41.5672 35.068 43.1848 32.4037 44.2884C29.7394 45.392 26.8838 45.96 24 45.96V48Z",
				stroke: "#4F49BA",
				strokeWidth: 4,
				mask: "url(#path-3-inside-2_2826_6939)"
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_2826_6939)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M22 27.172L31.192 17.979L32.607 19.393L22 30L15.636 23.636L17.05 22.222L22 27.172Z",
					fill: "#4F49BA"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-5-inside-3_2826_6939",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M0 24C-2.75532e-07 27.1517 0.620778 30.2726 1.82689 33.1844C3.033 36.0962 4.80083 38.742 7.02944 40.9706C9.25804 43.1992 11.9038 44.967 14.8156 46.1731C17.7274 47.3792 20.8483 48 24 48V45.96C21.1162 45.96 18.2606 45.392 15.5963 44.2884C12.932 43.1848 10.5111 41.5672 8.47193 39.5281C6.43276 37.4889 4.8152 35.068 3.7116 32.4037C2.60801 29.7394 2.04 26.8838 2.04 24H0Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 24C-2.75532e-07 27.1517 0.620778 30.2726 1.82689 33.1844C3.033 36.0962 4.80083 38.742 7.02944 40.9706C9.25804 43.1992 11.9038 44.967 14.8156 46.1731C17.7274 47.3792 20.8483 48 24 48V45.96C21.1162 45.96 18.2606 45.392 15.5963 44.2884C12.932 43.1848 10.5111 41.5672 8.47193 39.5281C6.43276 37.4889 4.8152 35.068 3.7116 32.4037C2.60801 29.7394 2.04 26.8838 2.04 24H0Z",
				stroke: "#4F49BA",
				strokeWidth: 4,
				mask: "url(#path-5-inside-3_2826_6939)"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-6-inside-4_2826_6939",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", { d: "M24 0C20.8483 -3.75839e-08 17.7274 0.620778 14.8156 1.82689C11.9038 3.033 9.25804 4.80083 7.02944 7.02944C4.80083 9.25805 3.033 11.9038 1.82689 14.8156C0.620777 17.7274 -4.75897e-07 20.8483 0 24H2.04C2.04 21.1162 2.60801 18.2606 3.7116 15.5963C4.8152 12.932 6.43276 10.5111 8.47193 8.47194C10.5111 6.43276 12.932 4.8152 15.5963 3.7116C18.2606 2.60801 21.1162 2.04 24 2.04V0Z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 0C20.8483 -3.75839e-08 17.7274 0.620778 14.8156 1.82689C11.9038 3.033 9.25804 4.80083 7.02944 7.02944C4.80083 9.25805 3.033 11.9038 1.82689 14.8156C0.620777 17.7274 -4.75897e-07 20.8483 0 24H2.04C2.04 21.1162 2.60801 18.2606 3.7116 15.5963C4.8152 12.932 6.43276 10.5111 8.47193 8.47194C10.5111 6.43276 12.932 4.8152 15.5963 3.7116C18.2606 2.60801 21.1162 2.04 24 2.04V0Z",
				stroke: "#4F49BA",
				strokeWidth: 4,
				mask: "url(#path-6-inside-4_2826_6939)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2826_6939",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_2826_6939",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(12 12)"
		})
	})] })]
});
export default SvgCheckmark;
